<template>
  <section :class="offersError ? 'offers-error' : 'offer-promos'" class="margin-bottom-xl">
    <div class="grid-x margin-bottom-s align-middle">
      <h3 class="cell shrink margin-right-xs">
        {{ OFFERPROMOS.title }}
      </h3>
      <div class="cell auto">
        <a :href="OFFERPROMOS.viewAllUrl" :class="OFFERPROMOS.linkStyle">{{ OFFERPROMOS.viewAllText }}</a>
      </div>
    </div>
    <div :class="filteredOffers.length === 0 ? 'acc-sect-wrapper margin-bottom-l' : 'margin-bottom-l'">
      <div v-if="offersList.notification.type">
        <Notification :severity="offersList.notification.type" :closable="false">
          <div class="grid-y">
            <div class="notification-heading">
              {{ offersList.serviceInterruption }}
            </div>
            <div class="notification-text">
              <p>{{ offersList.notification.message }}</p>
            </div>
          </div>
        </Notification>
      </div>
      <div v-else-if="offersError" class="offer-promos-error margin-top-s">
        <OfferPromosError />
      </div>
      <div v-else class="offer-promos-content margin-top-s">
        <div v-if="offersList.offers === null" class="grid-x grid-margin-x">
          <div class="cell large-4 medium-4 small-4">
            <Skeleton height="160px" />
          </div>
          <div class="cell large-4 medium-4 small-4">
            <Skeleton height="160px" />
          </div>
          <div class="cell large-4 medium-4 small-4">
            <Skeleton height="160px" />
          </div>
        </div>
        <Carousel v-else :list="filteredOffers">
          <template #item="slotProps">
            <PromoContent :offer="slotProps.data" />
          </template>
        </Carousel>
      </div>
    </div>
  </section>
</template>
<script setup>
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useDashboardStore } from '@/stores/useDashboardStore';
import Carousel from '@atomic-ui/carousel/Carousel';
import Notification from '@atomic-ui/notification/Notification';
import Skeleton from '@atomic-ui/skeleton/Skeleton';
import { OFFERPROMOS } from 'config';
import PromoContent from './PromoContent';
import OfferPromosError from './OfferPromosError';

const dashboardStore = useDashboardStore();
const maxDisplay = 3;

const { offersList, offersError } = storeToRefs(dashboardStore);

const filteredOffers = computed(() => {
  if (offersList.value?.offers?.length) {
    return offersList.value.offers.slice(0, maxDisplay);
  }
  return [];
});
</script>

<style lang="scss" scoped>
@import '~settingSCSS';

.offer-promos {
  margin-bottom: rem-calc(56);
  @include breakpoint(medium down) {
    margin-bottom: rem-calc(32);
  }
}
.p-message {
  margin: 0;
}
</style>
